import axios from "../../plugins/axios";

export const actions = {

    upload(context, payload) {
        const account = JSON.parse(localStorage.getItem('account'));

        return new Promise((resolve, reject) => {
            const formData = new FormData();
            formData.append('payload', payload.file);
            formData.append('ativar_robor_cemig', payload.ativar_robor_cemig);
            formData.append('controle_balanco_id', payload.controle_balanco_id);
            formData.append('referencia_balanco', payload.referencia_balanco);
            formData.append('upload_por', account.name);
            axios.post('balanco-energetico/payload', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            })
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    console.log(error)
                    reject(error);
                });
        });
    },
    verificarRoboCemig(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get('fix/verificar-robo-cemig')
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    console.log(error)
                    reject(error);
                });
        });
    },
    listarControleBalancos(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get('controle-balanco?'+payload)
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    console.log(error)
                    reject(error);
                });
        });
    },
    criarBalanco(context, payload) {
        return new Promise((resolve, reject) => {
            axios.post('controle-balanco/', payload)
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    console.log(error)
                    reject(error);
                });
        });
    },
    atualizarBalanco(context, payload) {
    return new Promise((resolve, reject) => {
        axios.put('controle-balanco/'+payload.id, payload)
            .then(response => {
                resolve(response);
            })
            .catch(error => {
                console.log(error)
                reject(error);
            });
    });
},
    obterBalancosFechados(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get('controle-balanco/obter-balancos-fechados')
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    console.log(error)
                    reject(error);
                });
        });
    }
}



// WEBPACK FOOTER //
// ./src/store/modules/controle-balanco.js